import { render, staticRenderFns } from "./myDistribution_1.vue?vue&type=template&id=70dae04e"
import script from "./myDistribution_1.vue?vue&type=script&lang=js"
export * from "./myDistribution_1.vue?vue&type=script&lang=js"
import style0 from "./myDistribution_1.vue?vue&type=style&index=0&id=70dae04e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports